import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../commonFunctions";
  
  const rp255 = {
    label: "ATM Reconcilation Register",
    starting: true,
    url: "rp255",
    pageLabel: "ATM Reconcilation Register",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Service Type",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options:[
                {
                    label:"ATM",
                    value:"ATM"
                },
                {
                    label:"POS",
                    value:"POS"
                },
                
            ],
            placeHolder: "",
            label: "",
            name: "servicetype",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Transaction Type",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options:[
                {
                    label:"Acquiers",
                    value:"Acquiers"
                },
                {
                    label:"Issuer",
                    value:"Issuer"
                },
                {
                    label:"On-Us",
                    value:"On-Us"
                },
                
            ],
            placeHolder: "",
            label: "",
            name: "transactiontype",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "From-To",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "fromdate",
            description: ""
          },


    ]
}
export default rp255